// AnalyticsBoot — mounted at the app root to kick off the analytics
// layer once. The hook listens to fw-consent-changed internally, so
// nothing else is needed.

import { useEffect } from 'react';
import { bootAnalytics } from '@/lib/analytics';

export function AnalyticsBoot() {
  useEffect(() => {
    bootAnalytics();
  }, []);
  return null;
}
